import React from 'react';

/**
 * Skip link component for keyboard navigation accessibility
 * Allows users to skip directly to main content
 */
const AccessibilitySkipLink = () => {
  const handleSkipToMain = (e) => {
    e.preventDefault();
    const mainContent = document.querySelector('main');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView();
    }
  };

  const handleSkipToNav = (e) => {
    e.preventDefault();
    const navigation = document.querySelector('[role="navigation"]');
    if (navigation) {
      const firstLink = navigation.querySelector('a, button');
      if (firstLink) {
        firstLink.focus();
      }
    }
  };

  return (
    <div className="sr-only focus-within:not-sr-only">
      <a
        href="#main-content"
        onClick={handleSkipToMain}
        className="skip-link bg-primary text-primary-foreground px-4 py-2 rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2"
      >
        Skip to main content
      </a>
      <a
        href="#main-navigation"
        onClick={handleSkipToNav}
        className="skip-link bg-primary text-primary-foreground px-4 py-2 rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 ml-2"
      >
        Skip to navigation
      </a>
    </div>
  );
};

export default AccessibilitySkipLink;